class WithdrawalForm extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    this.addEventListener('submit', this.#onSubmit);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.removeEventListener('submit', this.#onSubmit);
  }

  #onClick = (event) => {
    const button = event.target.closest('[data-action]');
    if (!button || !this.contains(button)) return;

    const action = button.getAttribute('data-action');

    if (action === 'review') {
      event.preventDefault();
      this.#showReview();
    } else if (action === 'edit') {
      event.preventDefault();
      this.#showFill();
    }
  };

  #onSubmit = (event) => {
    const form = event.target.closest('[data-withdrawal-form]');
    if (!form || !this.contains(form)) return;

    event.preventDefault();
    this.#submit();
  };

  #getEndpoint() {
    const path = this.getAttribute('data-withdrawal-endpoint');
    return new URL(path, window.location.origin).href;
  }

  #getForm() {
    return this.querySelector('[data-withdrawal-form]');
  }

  #showStep(step) {
    this.querySelectorAll('[data-step]').forEach((element) => {
      element.hidden = element.getAttribute('data-step') !== step;
    });

    const form = this.#getForm();
    if (form) form.hidden = step === 'success';
  }

  #showFill() {
    this.#clearStatus();
    this.#showStep('fill');
  }

  #showReview() {
    const form = this.#getForm();
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    this.querySelector('[data-summary-name]').textContent = form.querySelector('[name="name"]').value.trim();
    this.querySelector('[data-summary-email]').textContent = form.querySelector('[name="email"]').value.trim();
    this.querySelector('[data-summary-order]').textContent = form.querySelector('[name="orderNumber"]').value.trim();

    this.#clearStatus();
    this.#showStep('confirm');
  }

  #clearStatus() {
    const status = this.querySelector('[data-withdrawal-status]');
    if (status) status.innerHTML = '';
  }

  #showError(message) {
    const status = this.querySelector('[data-withdrawal-status]');
    if (!status) return;

    status.innerHTML = `<div class="banner banner--error">${this.#escapeHtml(message)}</div>`;
  }

  #showSuccess(message) {
    this.#clearStatus();
    this.#showStep('success');

    const messageElement = this.querySelector('[data-success-message]');
    if (messageElement) messageElement.textContent = message;
  }

  #escapeHtml(text) {
    const element = document.createElement('div');
    element.textContent = text;
    return element.innerHTML;
  }

  async #submit() {
    const form = this.#getForm();
    const submitButton = form.querySelector('[type="submit"]');

    submitButton?.setAttribute('aria-busy', 'true');
    submitButton?.setAttribute('disabled', '');

    const payload = {
      name: form.querySelector('[name="name"]').value.trim(),
      email: form.querySelector('[name="email"]').value.trim(),
      orderNumber: form.querySelector('[name="orderNumber"]').value.trim(),
      myshopifyDomain: form.querySelector('[name="myshopifyDomain"]').value
    };

    try {
      const response = await fetch(this.#getEndpoint(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      let data = {};
      try {
        data = await response.json();
      } catch {
        data = {};
      }

      if (response.ok) {
        this.#showSuccess(data.message);
        return;
      }

      this.#showError(data.message || this.getAttribute('data-error-message') || 'Something went wrong.');
      this.#showStep('confirm');
    } catch {
      this.#showError(this.getAttribute('data-error-message') || 'Something went wrong. Please try again.');
      this.#showStep('confirm');
    } finally {
      submitButton?.removeAttribute('aria-busy');
      submitButton?.removeAttribute('disabled');
    }
  }
}

if (!window.customElements.get('withdrawal-form')) {
  window.customElements.define('withdrawal-form', WithdrawalForm);
}
